import { ComponentType } from 'react';
import dynamic from 'next/dynamic';
import { ScreenType } from 'core/flow/entities';

interface ScreenComponentDefinition {
  Screen: ComponentType<{ screenId: string }>;
  importChunk: () => Promise<unknown>;
}

// TODO: remove after
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const screenComponents: Record<QuizStepTypes | ScreenType, ScreenComponentDefinition> = {
  [ScreenType.NEB_ANSWER]: {
    Screen: dynamic(() => import('./Answer').then((module) => module.AnswerStep)),
    importChunk: () => import('./Answer'),
  },
  [ScreenType.NEB_GOAL]: {
    Screen: dynamic(() => import('./Goal').then((module) => module.GoalStep)),
    importChunk: () => import('./Goal'),
  },
  [ScreenType.NEB_MULTIPLE_ANSWERS]: {
    Screen: dynamic(() => import('./MultipleAnswers').then((module) => module.MultipleAnswersStep)),
    importChunk: () => import('./MultipleAnswers'),
  },
  [ScreenType.NEB_ADDITIONAL_DISCOUNT]: {
    Screen: dynamic(() =>
      import('./AdditionalDiscount').then((module) => module.AdditionalDiscountStep),
    ),
    importChunk: () => import('./AdditionalDiscount'),
  },
  [ScreenType.NEB_SOCIAL_PROOF]: {
    Screen: dynamic(() => import('./SocialProof').then((module) => module.SocialProofStep)),
    importChunk: () => import('./SocialProof'),
  },
  [ScreenType.NEB_SPLIT]: {
    Screen: dynamic(() => import('./Split').then((module) => module.Split)),
    importChunk: () => import('./Split'),
  },
  [ScreenType.NEB_ONBOARDING]: {
    Screen: dynamic(() => import('./Onboarding').then((module) => module.OnboardingStep)),
    importChunk: () => import('./Onboarding'),
  },
  [ScreenType.NEB_DATE]: {
    Screen: dynamic(() => import('./Date').then((module) => module.DateStep)),
    importChunk: () => import('./Date'),
  },
  [ScreenType.NEB_LOADER_WITH_CONTENT]: {
    Screen: dynamic(() =>
      import('./LoaderWithContent').then((module) => module.LoaderWithContentStep),
    ),
    importChunk: () => import('./LoaderWithContent'),
  },
  [ScreenType.NEB_TIME]: {
    Screen: dynamic(() => import('./Time').then((module) => module.TimeStep)),
    importChunk: () => import('./Time'),
  },
  [ScreenType.NEB_TRIAL_PAYMENT]: {
    Screen: dynamic(() => import('./TrialPayment').then((module) => module.TrialPaymentStep)),
    importChunk: () => import('./TrialPayment'),
  },
  [ScreenType.NEB_TRIAL_CHOICE]: {
    Screen: dynamic(() => import('./TrialChoice').then((module) => module.TrialChoiceStep)),
    importChunk: () => import('./TrialChoice'),
  },
  [ScreenType.NEB_GENDER]: {
    Screen: dynamic(() => import('./Gender').then((module) => module.GenderStep)),
    importChunk: () => import('./Gender'),
  },
  [ScreenType.NEB_EMAIL_CONFIRM]: {
    Screen: dynamic(() => import('./EmailConfirm').then((module) => module.EmailConfirmStep)),
    importChunk: () => import('./EmailConfirm'),
  },
  [ScreenType.NEB_RELATIONSHIP_ZODIAC]: {
    Screen: dynamic(() => import('./Zodiac').then((module) => module.ZodiacStep)),
    importChunk: () => import('./Zodiac'),
  },
  [ScreenType.NEB_UPSELLS]: {
    Screen: dynamic(() => import('./Upsells').then((module) => module.UpsellsStep)),
    importChunk: () => import('./Upsells'),
  },
  [ScreenType.NEB_TRIAL_CREDITS]: {
    Screen: dynamic(() => import('./TrialCredits').then((module) => module.TrialCreditsStep)),
    importChunk: () => import('./TrialCredits'),
  },
  [ScreenType.NEB_PHONE_NUMBER]: {
    Screen: dynamic(() => import('./PhoneNumber').then((module) => module.PhoneNumberStep)),
    importChunk: () => import('./PhoneNumber'),
  },
  [ScreenType.NEB_TRIAL_PAYMENT_WITH_DISCOUNT]: {
    Screen: dynamic(() =>
      import('./TrialPaymentWithDiscount').then((module) => module.TrialPaymentWithDiscountStep),
    ),
    importChunk: () => import('./TrialPaymentWithDiscount'),
  },
  [ScreenType.NEB_W2A_PROMOTION]: {
    Screen: dynamic(() => import('./W2APromotion').then((module) => module.W2APromotionStep)),
    importChunk: () => import('./W2APromotion'),
  },
  [ScreenType.NEB_ONBOARDING_ASK]: {
    Screen: dynamic(() => import('./OnboardingAsk').then((module) => module.OnboardingAskStep)),
    importChunk: () => import('./OnboardingAsk'),
  },
  [ScreenType.NEB_EMAIL]: {
    Screen: dynamic(() => import('./Email').then((module) => module.EmailStep)),
    importChunk: () => import('./Email'),
  },
  [ScreenType.NEB_PLACE]: {
    Screen: dynamic(() => import('./Place').then((module) => module.PlaceStep)),
    importChunk: () => import('./Place'),
  },
};
